var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Фильтр по статусам")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.status,
                          expression: "filter.status",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.filter,
                            "status",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "0" } }, [
                        _vm._v("Все препараты"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.storeStatuses, function (s) {
                        return _c("option", { domProps: { value: s.id } }, [
                          _vm._v(_vm._s(s.title)),
                        ])
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Продажи")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.showWithSales,
                          expression: "filter.showWithSales",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.filter,
                            "showWithSales",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "0" } }, [
                        _vm._v("Без продаж"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("Были продажи"),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    !_vm.loading
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("p", [
                _vm._v("Всего препаратов: "),
                _c("strong", [_vm._v(_vm._s(_vm.totalRecords))]),
              ]),
              _vm._v(" "),
              Object.values(_vm.selectedDrug).filter((s) => s).length
                ? _c("div", [
                    _c("p", [
                      _vm._v("Выделено препаратов: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            Object.values(_vm.selectedDrug).filter((s) => s)
                              .length
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "ml-2 btn btn-xs btn-default",
                          attrs: { type: "button" },
                          on: { click: _vm.deselectAll },
                        },
                        [_vm._v("отменить выделенные")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newStatus,
                                expression: "newStatus",
                              },
                            ],
                            staticClass: "form-control w-50",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.newStatus = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.storeStatuses, function (s) {
                            return _c("option", { domProps: { value: s.id } }, [
                              _vm._v(_vm._s(s.title)),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("LoadingButton", {
                          attrs: {
                            title: "Сохранить",
                            type: "button",
                            loading: _vm.saveLoading,
                            color: _vm.$constants.SUCCESS_COLOR,
                            onClick: () => _vm.changeStatus(),
                            className: "btn btn-outline-success close_btn",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "table-component",
                {
                  ref: "table",
                  attrs: {
                    data: _vm.getDrugsByFilter(),
                    "table-class": "table",
                  },
                },
                [
                  _c("table-column", {
                    attrs: { label: "", sortable: false, filterable: false },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (row) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedDrug[row.drug.id],
                                    expression: "selectedDrug[row.drug.id]",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.selectedDrug[row.drug.id]
                                  )
                                    ? _vm._i(
                                        _vm.selectedDrug[row.drug.id],
                                        null
                                      ) > -1
                                    : _vm.selectedDrug[row.drug.id],
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.selectedDrug[row.drug.id],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selectedDrug,
                                              row.drug.id,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selectedDrug,
                                              row.drug.id,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.selectedDrug,
                                          row.drug.id,
                                          $$c
                                        )
                                      }
                                    },
                                    function ($event) {
                                      return _vm.holdShift(row.drug.id, $event)
                                    },
                                  ],
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2390840051
                    ),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      label: "ID",
                      show: "drug.id",
                      sortable: false,
                      filterable: false,
                    },
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: { show: "drug.title", label: "Препарат" },
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      show: "drug.priority",
                      "data-type": "numeric",
                      label: "Приоритет",
                      filterable: false,
                      sortable: false,
                    },
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      show: "inStores",
                      "data-type": "numeric",
                      label: "На складе",
                      filterable: false,
                    },
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      show: "sales",
                      label: "Продажи",
                      "data-type": "numeric",
                      filterable: false,
                    },
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: { show: "storeData.sorting", label: "Остаток" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (row) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    badge: true,
                                    "badge-success":
                                      row.storeData.sorting === 2,
                                    "badge-info": row.storeData.sorting === 1,
                                    "badge-warning":
                                      row.storeData.sorting === 0,
                                  },
                                },
                                [_vm._v(_vm._s(row.storeData.title))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1076637174
                    ),
                  }),
                  _vm._v(" "),
                  _c("table-column", {
                    attrs: {
                      label: "статус",
                      sortable: false,
                      filterable: false,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (row) {
                            return [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: row.drug.status,
                                      expression: "row.drug.status",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          row.drug,
                                          "status",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function ($event) {
                                        return _vm.changeStatus(
                                          row.drug.id,
                                          $event
                                        )
                                      },
                                    ],
                                  },
                                },
                                _vm._l(_vm.storeStatuses, function (s) {
                                  return _c(
                                    "option",
                                    { domProps: { value: s.id } },
                                    [_vm._v(_vm._s(s.title))]
                                  )
                                }),
                                0
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3282837299
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }